import * as STD           from '@emersya/mpa-std';
// ╭───────────────────────────────────────────────────────────────────────────╮
// │ ╳╳╳╳╳╳╳╳╳╳╳╳╳╳╳╳╳╳╳╳╳╳╳╳╳╳╳╳╳╳╳╳╳╳╳╳╳╳╳╳╳╳╳╳╳╳╳╳╳╳╳╳╳╳╳╳╳╳╳╳╳╳╳╳╳╳╳╳╳╳╳╳╳ │
// ╰───────────────────────────────────────────────────────────────────────────╯
// Component lifecycle
// |	Class
// |	|	declaration    #
// |	|	registration   #
// |	-	initialization #
// |	Instance
// |	|	Creation
// |	|	|	instantiation  #
// |	|	|	finalization   #
// |	|	|	initialization #
// -	-	-	startUp        #

const consoleCopy = {...console};

function generateConditionFromSchema(schema: Component.IConditionSchema) {
	function parser(src: string): Component.IConditionToken {
		function parseValue(v: any): Component.TConditionVariableValue {
			if (v instanceof Object) {
				return (v);
			}
			try {
				return (JSON.parse(v));
			} catch (e) {
				return ({variable: v});
			}
		};

		function cleanString(src: string) {
			return (
				src.replace(/\n/g, ' ').replace(/\t/g, ' ').split(' ').filter(x => x.length).join(' ')
			);
		};

		function tokenizeParser(src: string): Component.IConditionToken[] {
			return (
				src.split(' ').map((x): Component.IConditionToken => {
					if (
						(x === '&&') ||
						(x === '||') ||
						(x === '<') ||
						(x === '<=') ||
						(x === '>') ||
						(x === '>=') ||
						(x === '===') ||
						(x === '!==')
					) {
						return ({type: 'lexBin', value: x});
					} else if ((x === '(') || (x === ')')) {
						return ({type: 'lexGroup', value: x});
					}
					return ({type: 'value', value: x});
				}).reduce((a, c, i, ra) => {
					if (c.counted) {
						return (a);
					}
					if (ra[i - 2]) {
						if (
							((<Component.IConditionToken>ra[i]).type === 'value') &&
							((<Component.IConditionToken>ra[i - 1]).type === 'lexBin') &&
							((<Component.IConditionToken>ra[i - 2]).type === 'value')
						) {
							a.push({
								type: 'bin',
								ctype: <string>(<Component.IConditionToken>ra[i - 1]).value,
								LHS: parseValue((<Component.IConditionToken>ra[i - 2]).value),
								RHS: parseValue(c.value)
							});
							(<Component.IConditionToken>ra[i]).counted = true;
							(<Component.IConditionToken>ra[i - 1]).counted = true;
							(<Component.IConditionToken>ra[i - 2]).counted = true;
							return (a);
						}
					}
					a.push(c);
					return (a);
				}, <Component.IConditionToken[]>[]).filter(x => !x.counted)
			);
		};
		let tokens = tokenizeParser(cleanString(src));
		while (tokens.length !== 1) {
			tokens = (
				tokens.reduce((a, c, i, ra) => {
					if (c.counted) {
						return (a);
					}
					if (ra[i - 2]) {
						if (
							((<Component.IConditionToken>ra[i]).type === 'lexGroup') &&
							((<Component.IConditionToken>ra[i]).value === ')') &&
							((<Component.IConditionToken>ra[i - 1]).type === 'bin') &&
							((<Component.IConditionToken>ra[i - 2]).type === 'lexGroup') &&
							((<Component.IConditionToken>ra[i - 2]).value === '(')
						) {
							(<Component.IConditionToken>ra[i]).counted = true;
							(<Component.IConditionToken>ra[i - 2]).counted = true;
							return a;
						}
					}
					a.push(c);
					return a;
				}, <Component.IConditionToken[]>[]).filter(x => !x.counted).reduce((a, c, i, ra) => {
					if (c.counted) {
						return (a);
					}
					if (ra[i - 2]) {
						if (
							((<Component.IConditionToken>ra[i]).type === 'bin') &&
							((<Component.IConditionToken>ra[i - 1]).type === 'lexBin') &&
							((<Component.IConditionToken>ra[i - 2]).type === 'bin')
						) {
							a.push({
								type: 'bin',
								ctype: <string>(<Component.IConditionToken>ra[i - 1]).value,
								LHS: ra[i - 2],
								RHS: c
							});
							(<Component.IConditionToken>ra[i]).counted = true;
							(<Component.IConditionToken>ra[i - 1]).counted = true;
							(<Component.IConditionToken>ra[i - 2]).counted = true;
							return (a);
						}
					}
					a.push(c);
					return a;
				}, <Component.IConditionToken[]>[]).filter(x => {
					if (!x.counted) {
						return (true);
					} else {
						delete x.counted;
						return (false);
					}
				}).reduce((a, c, i, ra) => {
					if (c.counted) {
						return (a);
					}
					if (ra[i - 2]) {
						if (
							((<Component.IConditionToken>ra[i]).type === 'lexGroup') &&
							((<Component.IConditionToken>ra[i]).value === ')') &&
							((<Component.IConditionToken>ra[i - 1]).type === 'bin') &&
							((<Component.IConditionToken>ra[i - 2]).type === 'lexGroup') &&
							((<Component.IConditionToken>ra[i - 2]).value === '(')
						) {
							(<Component.IConditionToken>ra[i]).counted = true;
							(<Component.IConditionToken>ra[i - 2]).counted = true;
							return a;
						}
					}
					a.push(c);
					return a;
				}, <Component.IConditionToken[]>[]).filter(x => {
					if (!x.counted) {
						return (true);
					} else {
						delete x.counted;
						return (false);
					}
				})
			);
		}
		if (tokens.length !== 1) {
			throw new SyntaxError('!!!');
		}
		return (<Component.IConditionToken>tokens[0]);
	};

	function generate(
		token: Component.IConditionToken,
		variables: Component.TConditionVariables
	): TCondition.TSerialized {
		if ((token.ctype === '||') || (token.ctype === '&&')) {
			return {
				type: (token.ctype === '||') ? 'or' : 'and',
				LHS: generate(<Component.IConditionToken>token.LHS, variables),
				RHS: generate(<Component.IConditionToken>token.RHS, variables)
			};
		} else {
			const variable = <Component.IConditionVariableCP>variables[(<any>token.LHS).variable];
			return {
				type: (
					(token.ctype === '===') ? 'equal' :
						(token.ctype === '!==') ? 'notequal' :
							(token.ctype === '<') ? 'inferior' :
								(token.ctype === '<=') ? 'inferiorequal' :
									(token.ctype === '>') ? 'superior' :
										(token.ctype === '>=') ? 'superiorequal' : <any>new Error
				),
				component: variable.component,
				property: variable.property,
				value: <STD.object.JSON>token.RHS
			};
		}
	};
	const src = (
		(typeof schema.src === 'string') ? schema.src :
			schema.src.join('\n')
	);
	const variables = Object.entries(schema.variables).reduce((a, [key, value]) => {
		const [component, property] = <[string, string]>value.split('<=>');
		a[key] = {
			component: component.trim(),
			property: property.trim()
		};
		return (a);
	}, <Component.TConditionVariables>{});
	return generate(parser(src), variables);
};
// ╭───────────────────────────────────────────────────────────────────────────╮
// │ ╳╳╳╳╳╳╳╳╳╳╳╳╳╳╳╳╳╳╳╳╳╳╳╳╳╳╳╳╳╳╳╳╳╳╳╳╳╳╳╳╳╳╳╳╳╳╳╳╳╳╳╳╳╳╳╳╳╳╳╳╳╳╳╳╳╳╳╳╳╳╳╳╳ │
// ╰───────────────────────────────────────────────────────────────────────────╯
abstract class Component<
	TComponent extends Component<TComponent, TConfiguration>,
	TConfiguration extends Component.IConfiguration
> extends STD.events.Target<TComponent, Component<any, any>> {
	// ╔════════════════════════════════════════════════════════════════╗
	// ║ 	CLASS                                                         ║
	// ╟────────────────────────────────────────────────────────────────╢
	// ║                                                                ║
	// ║                                                                ║
	// ╚════════════════════════════════════════════════════════════════╝
	static uid = 0;
	static type: string;
	static isFullyDeclared = false;
	static isInitialized = false;
	static manifest: TManifest.ComponentManifest | null = null;
	static declarationDescriptor: TManager.IDeclareDescriptor<any>;
	static inheritanceChain: typeof Component[] = [];
	static hasDebugEnabled = false;

	static getInstances(this: Component.TAnyConcrete): Component<any, any>[] {
		const instances = window.MPAComponentsManager.Manager.storeInstancesByType.get(this);
		if (!instances) {
			const self = window.MPAComponentsManager.Manager.getClassProxyOrThrow(this.type);
			if (self) {
				return self.getInstances();
			}
			throw STD.errors.library('The context is not a component nor a component proxy', {
				context: this
			});
		}
		return instances;
	};

	static finalizeDeclaration() {
		if (this.hasOwnProperty('isFullyDeclared') && this.isFullyDeclared) {
			return;
		}
		const desc = this.declarationDescriptor;

		let parent = <typeof Component>(<any>this.prototype).__proto__.constructor;
		while (parent !== Component && parent.name !== 'DOMComponent') {
			if (!parent.hasOwnProperty('isFullyDeclared') || !parent.isFullyDeclared) {
				parent.finalizeDeclaration();
			} else {
				/** Stops at the first finalized parent because the others are necessarily finalized too. **/
				break;
			}
			parent = <typeof Component>(<any>parent.prototype).__proto__.constructor;
		}

		if (desc.manifest) {
			const parentManifest = (<typeof Component>(<any>this.prototype).__proto__.constructor).manifest || null;
			this.manifest = window.MPAComponentsManager.Manifest.create('???', desc.manifest, 'component', parentManifest);
			if (this.manifest.error) {
				throw this.manifest.error;
			}
		}
		if (!this.hasOwnProperty('isInitialized') || !this.isInitialized) {
			this.initialize();
		}
		this.isFullyDeclared = true;
		this.inheritanceChain = [this, ...(<typeof Component>(<any>this.prototype).__proto__.constructor).inheritanceChain];
	};

	static initialize() {
		STD.events.Target.initializeEventsTarget.call(this);
		STD.events.Target.declareEventType.call(this, 'start');
		STD.events.Target.declareEventType.call(this, 'remove');
		STD.events.Target.declareEventType.call(this, 'internal-activation', 'enabled');
		STD.events.Target.declareEventType.call(this, 'internal-activation', 'disabled');
		STD.events.Target.declareEventType.call(this, 'activation', 'enabled');
		STD.events.Target.declareEventType.call(this, 'activation', 'disabled');
		/** See replicator component **/
		STD.events.Target.declareEventType.call(this, 'replication', 'enable');
		STD.events.Target.declareEventType.call(this, 'replication', 'disable');
		STD.events.Target.declareEventType.call(this, 'replica-update');
		this.isInitialized = true;
	};

	private static component_debugQueue: (() => Promise<void>)[] = [];
	private static component_debugIsRunning = false;

	static component_debugTx(fn: () => Promise<void> | void): void {
		const wrapped = async () => {
			try {
				await fn();
			} catch (err) {
				console.error('[component_debugTx] Error in transaction:', err);
			}
		};
		Component.component_debugQueue.push(wrapped);
		if (!Component.component_debugIsRunning) {
			Component.component_debugIsRunning = true;
			void (async () => {
				while (Component.component_debugQueue.length > 0) {
					const next = Component.component_debugQueue.shift()!;
					await next();
				}
				Component.component_debugIsRunning = false;
			})();
		}
	};

	// ╔════════════════════════════════════════════════════════════════╗
	// ║ INSTANCE                                                       ║
	// ╟────────────────────────────────────────────────────────────────╢
	// ║                                                                ║
	// ║                                                                ║
	// ╚════════════════════════════════════════════════════════════════╝
	/**
	 * @deprecated
	 **/
	component_log(...x: any[]) {
		debugger;
		console.log({x});
	};

	component_debug(message: string, data?: object) {
		const frames = STD.errors.StackFrames.fromPosition();
		Component.component_debugTx(async () => {
			const componentReference = `${this.static.type}(${this.id}[${this.component_uid}])`;
			consoleCopy.log.call(consoleCopy, await frames);
			const method = (
				await frames
			).frames[1]?.functionName || 'unknown';
			const prefix = `${componentReference}.${method}:`;
			message = `${prefix} ${message}`;
			if (data) {
				consoleCopy.log.call(consoleCopy, message, data);
			} else {
				consoleCopy.log.call(consoleCopy, message);
			}
		});
	};

	// ┏━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━┓
	// ┃ ACTIVATIONS MANAGEMENT                                         ┃
	// ┠────────────────────────────────────────────────────────────────┨
	// ┃                                                                ┃
	// ┃                                                                ┃
	// ┃                                                                ┃
	// ┃                                                                ┃
	// ┃                                                                ┃
	// ┃                                                                ┃
	// ┗━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━┛
	component_condition: TCondition.TCondition | null = null;
	/** type of deactivation: condition, parent, configuration **/
	component_activation = {
		preventedByCondition: false, // A condition prevents the component to be enabled.
		preventedByDisabledParent: false, // A parent is disabled, so the component cannot be enabled.
		preventedByConfiguration: false, // Explicitly disabled.
		isDisabled: false
	};

	get component_isDisabled() {
		return (this.component_activation.isDisabled);
	};

	async component_updateActivation(enableInternalEvent = true) {
		const isDisabled = (
			this.component_activation.preventedByCondition ||
			this.component_activation.preventedByDisabledParent ||
			this.component_activation.preventedByConfiguration
		);
		if (isDisabled === this.component_activation.isDisabled) {
			return; // Already updated
		}
		this.component_activation.isDisabled = isDisabled;
		const eventName = isDisabled ? 'disabled' : 'enabled';
		if (enableInternalEvent) {
			await this.dispatchEvent('internal-activation', {
				subType: eventName,
				bubblingType: 'childs',
				bubblingDirection: 'down'
			});
		}
		await this.dispatchEvent('activation', {
			subType: eventName
		});
	};

	async component_toggleActivation() {
		if (this.component_activation.isDisabled) {
			await this.component_enable();
		} else {
			await this.component_disable();
		}
	};

	async component_enable() {
		try {
			this.component_activation.preventedByConfiguration = false;
			await this.component_updateActivation();
		} catch (error: any) {
			throw STD.errors.bindAsBound('Cannot enable component!', {component: this}, error);
		}
	};

	async component_disable() {
		if (!this.component_isStarted && !this.component_isStarting) {
			this.component_throwUserError('Cannot disable a component before starting it!', {});
		}
		try {
			this.component_activation.preventedByConfiguration = true;
			await this.component_updateActivation();
		} catch (error: any) {
			this.component_throwBoundError('Cannot disable component!', {}, error);
		}
	};

	async component_disableIfIsEnabled() {
		if (!this.component_isDisabled) {
			await this.component_disable();
		}
	};

	component_isActive(): boolean {
		if (this.component_parent === null) {
			return (true);
		}
		return (this.component_parent.component_childIsActive(this));
	};

	component_childIsActive(child: Component<any, any>) {
		if (this.component_parent) {
			if (
				!child.component_isDisabled &&
				this.component_parent.component_childIsActive(this)
			) {
				return true;
			} else {
				return false;
			}
		} else {
			return !child.component_isDisabled &&
				!this.component_isDisabled
				;
		}
	};

	protected async component_onInternalActivation(ev: STD.events.Event<any, Component<any, any>>) {
		const eventName = <string>ev.subType;
		if (eventName === 'enabled') {
			if (ev && (ev.target !== this)) {
				this.component_activation.preventedByDisabledParent = false;
			}
			if (this.component_activation.preventedByConfiguration || this.component_activation.preventedByCondition) {
				//The component now have their parents enabled but itself not ready so do not handle their childs
				ev.stopPropagation();
			}
		} else if (eventName === 'disabled') {
			const isAlreadyDisabled = this.component_activation.isDisabled;
			//An ancestor was disabled
			if (ev && (ev.target !== this)) {
				this.component_activation.preventedByDisabledParent = true;
				//useless to handle childs if already disabled
				if (isAlreadyDisabled) {
					ev.stopPropagation();
				}
			}
		}
		await this.component_updateActivation(false);
	};

	/**
	 * Placeholder for standard onEnabled/onDisabled handling extension point
	 * This method will be called automatically
	 **/
	protected async component_onActivationChange(event: STD.events.Event<any, Component<any, any>>) {
		await <any>void event;
	};

	/**
	 * Return true if no condition prevents component to be enabled
	 **/
	async component_evaluateCondition(report: TCondition.IEvaluationReportItem[] = []): Promise<boolean> {
		if (!this.component_condition) {
			return true;
		}
		if (!(report instanceof Array)) {
			report = [];
		}
		let predicateIsTrue: boolean;
		try {
			predicateIsTrue = await this.component_condition.evaluate(this, report);
		} catch (error: any) {
			throw STD.errors.bindAsBound('Component.evaluateCondition: condition error', {
				component: this
			}, error);
		}
		this.component_activation.preventedByCondition = !predicateIsTrue;
		await this.component_updateActivation();
		return (predicateIsTrue);
	};

	async component_evaluateAllConditions() {
		for (const c of this.component_innerChilds) {
			await c.component_evaluateAllConditions();
		}
		for (const c of this.component_outerChilds) {
			await c.component_evaluateAllConditions();
		}
		await this.component_evaluateCondition();
	};

	// ┏━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━┓
	// ┃ TRANSLATIONS MANAGEMENT                                        ┃
	// ┠────────────────────────────────────────────────────────────────┨
	// ┃                                                                ┃
	// ┃                                                                ┃
	// ┃                                                                ┃
	// ┃                                                                ┃
	// ┃                                                                ┃
	// ┃                                                                ┃
	// ┗━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━┛
	component_translations = <string[]>[];
	component_linkedTranslations = <{ [key: string]: string }>{};

	component_defineTranslation(
		suffix: string,
		obj: STD.translationsManager.TranslationMapping | string,
		tryFallbackIfMissingLanguages = true
	) {
		let trId;
		if (typeof obj === 'object') {
			trId = this.component_generateTranslationId(suffix);
			this.component_translations.push(trId);
			STD.translationsManager.addObject(trId, obj, tryFallbackIfMissingLanguages);
		} else {
			trId = obj;
			this.component_linkedTranslations[suffix] = trId;
		}
		return (trId);
	};

	component_getTranslated(suffix: string) {
		let trId = this.component_translations.find(function (x) {
			return (x.endsWith(suffix));
		});
		if (trId === undefined) {
			trId = this.component_linkedTranslations[suffix];
			if (trId === undefined) {
				this.component_throwUserError(
					`Unknown translation suffix<${suffix}>!`,
					{suffix}
				);
			}
		}
		return (STD.translationsManager.get(trId, STD.translationsManager.language));
	};

	component_generateTranslationId(suffix: string) {
		return ('components.' + this.static.type + '.' + this.component_uid + '.' + suffix);
	};

	component_getTranslationId(suffix: string) {
		return (this.component_translations.find(function (x) {
			return (x.endsWith(suffix));
		}));
	};

	component_hasTranslation(suffix: string) {
		return (this.component_getTranslationId(suffix) !== undefined);
	};

	// ┏━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━┓
	// ┃ TREE STRUCTURE MANAGEMENT                                      ┃
	// ┠────────────────────────────────────────────────────────────────┨
	// ┃                                                                ┃
	// ┃                                                                ┃
	// ┃                                                                ┃
	// ┃                                                                ┃
	// ┃                                                                ┃
	// ┃                                                                ┃
	// ┗━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━┛
	component_parent: Component<any, any> | null;
	component_parentSlot: Component<any, any> | null = null;
	component_innerChilds: Component<any, any>[] = [];
	component_outerChilds: Component<any, any>[] = [];
	component_isSlot: boolean;
	component_slotsRecords: Record<string, Component<any, any>> = {};
	component_tree: Component<any, any>;
	component_initialPath!: string;

	component_getChildPath(
		child: Component<any, any>,
		isFullExpected = false
	) {
		if (!isFullExpected) {
			if (child.id === '-') {
				return this.component_getPath();
			}
			return this.component_getPath() + '.' + child.id;
		}
		if (this.component_hasInnerTree() && this.component_innerChilds.includes(child)) {
			return this.component_getPath(isFullExpected) + ':' + child.id;
		}
		return this.component_getPath(isFullExpected) + '.' + child.id;
	};

	component_getPath(isFullExpected = false): string {
		isFullExpected = true;
		if (!this.component_parent) {
			return this.id;
		} else {
			// if (
			// 	!this.component_isInitialized &&
			// 	this.component_parent.component_hasInnerTree() &&
			// 	(this.component_tree !== this.component_parent.component_tree)
			// )
			// {
			// 	if (this.component_parentSlot) {
			// 		return (this.component_parentSlot.component_getPath() + '.' + this.id);
			// 	} else {
			// 		return (this.component_parent.component_getPath() + ':' + this.id);
			// 	}
			// }
			return (this.component_parent.component_getChildPath(this, isFullExpected));
		}
	};

	component_getInnerChildPath(
		child: { id: Component.TId },
		isFullExpected = false
	) {
		if (this.component_hasInnerTree()) {
			return (child.id);
		}
		if (!isFullExpected) {
			if (child.id === '-') {
				return (this.component_getInnerPath());
			}
			return (this.component_getInnerPath() + '.' + child.id);
		}
		return (this.component_getInnerPath(isFullExpected) + '.' + child.id);
	};

	component_getInnerPath(isFullExpected = false): string {
		if ((this.component_parent === null) || this.component_parent.component_hasInnerTree()) {
			return (this.id);
		} else {
			return (this.component_parent.component_getInnerChildPath(this, isFullExpected));
		}
	};

	async component_appendInnerChild(
		component: Component<any, any>,
		parent: HTMLElement | null = null
	) {
		void parent;
		await <Promise<void>><any>void 1;
		this.component_innerChilds.push(component);
		component.component_parent = this;
	};

	component_getRelativeParentPath(parent: Component<any, any>) {
		if (this === parent) {
			this.component_throwUserError('Cannot get relative path if this is parent!', {
				parent
			});
		}
		let currentTarget: Component<any, any> | null = this;
		const path: string[] = [];
		while (currentTarget && (currentTarget !== parent)) {
			const p: Component<any, any> | null = currentTarget.component_parent;
			// !!! IS NOT THE SAME LOGIC AS OTHER PARTS!!
			// !!! BUT NOW I HAVE CONVERTED THEM... SO!!
			if (p?.component_innerChilds.includes(currentTarget)) {
				path.unshift(':' + currentTarget.id);
			} else {
				path.unshift('.' + currentTarget.id);
			}
			currentTarget = currentTarget.component_parent;
		}
		if (!currentTarget) {
			this.component_throwUserError('Parent not found!', {parent});
		}
		return (path.join(''));
	};

	async component_appendOuterChild(
		component: Component<any, any>,
		_slot: string | HTMLElement,
		insertionType: 'child' | 'before' = 'child'
	) {
		void insertionType;
		await <Promise<void>><any>void 1;
		let slotComponent: Component<any, any> | null | undefined;
		if (_slot instanceof HTMLElement) {
			slotComponent = window.MPAComponentsManager.DOMComponent.getFromDOM(_slot);
		} else {
			slotComponent = this.component_slotsRecords[_slot];
			if (!(slotComponent instanceof window.MPAComponentsManager.DOMComponent) && this instanceof window.MPAComponentsManager.DOMComponent) {
				throw new Error('Not implemented');
			}
		}
		if (!slotComponent) {
			this.component_throwUserError(
				`Component.appendOuterChild@slot<${_slot}> not found!`
				,
				{
					path: this.component_getPath(),
					slot: _slot,
					componentToAppend: component
				}
			);
		}
		if (component.component_parent) {
			component.component_parent.component_outerChilds = component.component_parent.component_outerChilds.filter(x => x !== component);
			component.component_parent.component_innerChilds = component.component_parent.component_innerChilds.filter(x => x !== component);
		}
		this.component_outerChilds.push(component);
		component.component_parentSlot = (slotComponent !== this) ? slotComponent : null;
		component.component_parent = this;
	};

	private component_getChildFullPath(childId: string, isInnerChild: boolean) {
		return `${this.component_getPath()}${isInnerChild ? ':' : '.'}${childId}`;
	};

	private async component_instantiateChild(
		desc: Component.TInstantiateChildDescriptor<any>,
		isInnerChild: boolean
	): Promise<Component.TAny> {
		try {
			const rootManifest = window.MPAComponentsManager.Manager.manifest;
			const manifest: {
				referer: Component<any, any>;
				manifest: TManifest.TManifest;
			} = this.component_getParentManifest();
			let currentManifest = manifest;
			const configurations: Component.IConfiguration[] = [];
			let target: Component<any, any> = this;
			const suffixId = desc.id;
			const fullPath = this.component_getChildFullPath(desc.id, isInnerChild);
			while (currentManifest.manifest !== rootManifest) {
				const localPath = (
					'template.' +
					this.component_getRelativeParentPath(currentManifest.referer).slice(1) +
					'.' +
					suffixId
				);
				const localParsedPath = window.MPAComponentsManager.Path.parse(localPath);
				for (const [selector, configuration] of Object.entries(currentManifest.manifest.dynamicConfigurations)) {
					const selectorParsedPath = window.MPAComponentsManager.Path.parse(selector);
					if (localParsedPath.isEqualTo(selectorParsedPath)) {
						configurations.push(configuration);
					}
				}
				const localConfiguration = currentManifest.manifest.configurations[localPath];
				if (localConfiguration) {
					configurations.push(localConfiguration);
				}
				const tmp = target.component_getParentManifest();
				target = currentManifest.referer;
				currentManifest = tmp;
			}
			const userDefinedConfiguration = rootManifest.configurations[fullPath];
			if (userDefinedConfiguration && userDefinedConfiguration['@marker'] !== desc.configuration['@marker']) {
				configurations.push(userDefinedConfiguration);
			}
			for (const [selector, configuration] of Object.entries(rootManifest.dynamicConfigurations)) {
				const parsedFullPath = window.MPAComponentsManager.Path.parse(fullPath);
				const selectorParsedPath = window.MPAComponentsManager.Path.parse(selector);
				if (parsedFullPath.isEqualTo(selectorParsedPath)) {
					configurations.push(configuration);
				}
			}
			target = this;
			const innerPath = isInnerChild ?
				this.component_getInnerChildPath(desc) :
				this.component_getInnerPath() + '.' + this.component_getInnerChildPath(desc);
			const subc = [
				(this.component_configuration['@innerConfigurations'] || {})[desc.id],
				(this.component_tree.component_configuration['@innerConfigurations'] || {})[innerPath]
			].filter(x => x);
			const inheritedConfigurations = Array.from(new Set(configurations));
			const cfg = STD.object.deepMerge.all(
				[{}, desc.configuration, ...subc, ...inheritedConfigurations],
				{
					isMergeableObject: x => x && x.constructor && ((x instanceof Array) || (x.constructor === Object))
				}
			);
			const component = await window.MPAComponentsManager.Manager.instantiate({
				type: desc.type,
				id: desc.id,
				configuration: cfg,
				parent: this,
				isRoot: false,
				tree: desc.tree,
				slot: desc.slot,
				...(desc.isSlot ? {
					isSlot: true,
					declaredSlot: desc.declaredSlot
				} : {
					isSlot: false
				})
			});
			if (isInnerChild) {
				await this.component_appendInnerChild(component, desc.parentNode);
				if (component.component_isSlot) {
					const descriptor = <IDescriptorSlot>component.descriptor;
					if (!descriptor.declaredSlot) {
						this.component_throwUserError('Component is a slot but has no declared slot!', {});
					}
					if (!(component instanceof window.MPAComponentsManager.DOMComponent)) {
						this.component_throwUserError('Only DOMComponent can be a slot!', {});
					}
					component.component_tree.component_slotsRecords[descriptor.declaredSlot] = component;
				}
			} else {
				const slot = desc.beforeNode ? desc.beforeNode : (desc.parentNode ? desc.parentNode : (desc.slot || 'default'));
				await this.component_appendOuterChild(component, slot, desc.beforeNode ? 'before' : 'child');
			}
			return component;
		} catch (error: any) {
			throw STD.errors.bindAsBound('Cannot instantiate child!', {
				parent: this,
				desc
			}, error);
		}
	};

	async component_instantiateInnerChild(
		desc: Component.TInstantiateChildDescriptor<any>
	): Promise<Component.TAny> {
		return await this.component_instantiateChild(desc, true);
	};

	async component_instantiateOuterChild<
		TConfiguration extends Component.IConfiguration = any
	>(
		desc: Component.TInstantiateChildDescriptor<TConfiguration>
	): Promise<Component.TAny> {
		return await this.component_instantiateChild(desc, false);
	};

	component_isSameTree(rhs: Component<any, any>) {
		void rhs;
		return (false);
	};

	/**
	 * @deprecated
	 ***/
	component_findInner(path: string[]): Component<any, any> | undefined {
		const id = path.shift();
		let child = this.component_innerChilds.find(x => x.id === id);
		if (child === undefined) {
			const noIds = (
				this.component_innerChilds.filter(x => x.id === '-').map(x => x.component_innerChilds).flat()
			);
			child = noIds.find(x => x.id === id);
		}
		if ((child === undefined) || (path.length === 0)) {
			return child;
		}
		return child.component_findInner(path);
	};

	component_findOuter(path: string[]): Component<any, any> | undefined {
		const id = path.shift();
		let child = this.component_outerChilds.find(x => {
			return (x.id === id);
		});
		if (child === undefined) {
			const noIds = (
				this.component_outerChilds.filter(x => x.id === '-').map(x => x.component_outerChilds).flat()
			);
			child = noIds.find(x => {
				return (x.id === id);
			});
		}
		if ((child === undefined) || (path.length === 0)) {
			return (child);
		}
		return (child.component_findOuter(path));
	};

	component_findMaybe(
		pathRaw: Path.TPathRaw | Path.TPath
	): Component<any, any> | undefined {
		const path = this.normalizePath(pathRaw);
		const pathNodes = path.path;
		let c: Component<any, any>;
		let startIndex = 0;
		if (path.type === 'absolute') {
			c = window.MPAComponentsManager.Manager.root;
			startIndex = 1; // Skip first component because is root.
		} else {
			c = this;
			for (let i = 0; i < path.ascendsCount; i++) {
				if (!c.component_parent) {
					this.component_throwUserError('Invalid path', {
						path,
						pathRaw,
						currentComponent: c
					});
				}
				c = c.component_parent;
			}
		}
		try {
			const nodesCount = pathNodes.length;
			if (nodesCount === 0) {
				return c;
			}
			for (let i = startIndex; i < nodesCount; i++) {
				const pathNode = <Path.IPathNode>pathNodes[i];
				if (pathNode.id === '**') {
					if (i === nodesCount - 1) {
						this.component_throwUserError('Cannot use wildcard on the last element of a path!', {
							path,
						});
					}
					const store = (pathNode.location === 'inner') ? c.component_innerChilds : c.component_outerChilds;
					return store.map(x => x.component_findMaybe(path.slice(i + 1))).
					filter(x => x)[0];
				} else {
					const store = (pathNode.location === 'inner') ? c.component_innerChilds : c.component_outerChilds;
					const temporaryNode = store.find(x => x.id === pathNode.id);
					if (!temporaryNode) {
						return temporaryNode;
					}
					c = temporaryNode;
				}
			}
			return c;
		} catch (error: any) {
			STD.errors.handle(error, {
				userError() {
					throw error;
				},
				libraryError() {
					throw STD.errors.bindAsBound('Unexpected error', {path}, error);
				}
			});
			throw new Error('never');
		}
	};

	component_find(
		path: Path.TPathRaw | Path.TPath
	) {
		const component = this.component_findMaybe(path);
		if (!component) {
			this.component_throwUserError('Component not found!', {path});
		}
		return component;
	};

	component_findChild(id: string): Component<any, any> {
		const child: Component<any, any> | undefined = (
			this.component_innerChilds.find(x => x.id === id) ||
			this.component_outerChilds.find(x => x.id === id)
		);
		if (!child) {
			this.component_throwUserError('Child not found!', {childId: id});
		}
		return (child);
	};

	private normalizePath(
		pathRaw: Path.TPathRaw | Path.TPath
	): Path.TPath {
		if (typeof pathRaw === 'string') {
			return window.MPAComponentsManager.Path.parse(pathRaw);
		}
		return pathRaw;
	}

	component_findAll(
		pathRaw: Path.TPathRaw | Path.TPath,
		isInitialCall = true
	): Component<any, any>[] {
		const path = this.normalizePath(pathRaw);
		const pathNodes = path.path;
		if (isInitialCall && !pathNodes.some(x => x.id === '**')) {
			this.component_throwUserError('Cannot findAll on a path without wildcards!', {
				pathRaw
			});
		}
		let c: Component<any, any>;
		let startIndex = 0;
		if (path.type === 'absolute') {
			c = window.MPAComponentsManager.Manager.root;
			startIndex = 1; // Skip first component because is root.
		} else {
			c = this;
			for (let i = 0; i < path.ascendsCount; i++) {
				if (!c.component_parent) {
					this.component_throwUserError('Invalid path', {
						path,
						pathRaw,
						currentComponent: c
					});
				}
				c = c.component_parent;
			}
		}
		try {
			const nodesCount = pathNodes.length;
			if (nodesCount === 0) {
				return [c];
			}
			for (let i = startIndex; i < nodesCount; i++) {
				const pathNode = <Path.IPathNode>pathNodes[i];
				if (pathNode.id === '**') {
					if (i === nodesCount - 1) {
						this.component_throwUserError('Cannot use wildcard on the last element of a path!', {
							path,
						});
					}
					const store = (pathNode.location === 'inner') ? c.component_innerChilds : c.component_outerChilds;
					return store.
					map(x => x.component_findAll(path.slice(i + 1), false)).flat();
				} else {
					const store = (pathNode.location === 'inner') ? c.component_innerChilds : c.component_outerChilds;
					const temporaryNode = store.find(x => x.id === pathNode.id);
					if (!temporaryNode) {
						return [];
					}
					c = temporaryNode;
				}
			}
			return [c];
		} catch (error: any) {
			STD.errors.handle(error, {
				userError() {
					throw error;
				},
				libraryError() {
					throw STD.errors.bindAsBound('Unexpected error', {path}, error);
				}
			});
			throw new Error('never');
		}
	};

	component_getRoot() {
		let c = <Component<any, any>>this;
		while (c.component_parent !== null) {
			c = c.component_parent;
		}
		return (c);
	};

	//Remove component from the graph
	async component_remove() {
		await this.dispatchEvent('remove', {
			// bubblingDirection : 'up-down'
		});
		const p = this.component_parent;
		if (p) {
			const innerIdx = p.component_innerChilds.indexOf(this);
			if (innerIdx !== -1) {
				p.component_innerChilds.splice(innerIdx, 1);
			} else {
				const outerIdx = p.component_outerChilds.indexOf(this);
				p.component_outerChilds.splice(outerIdx, 1);
			}
		}
		this.component_parent = null;
		this.component_parentSlot = null;
		this.component_tree = this;
	};

	component_hasInnerTree() {
		return (this.static.manifest !== null);
	};

	override getParent() {
		return (this.component_parent || this.component_parentSlot);
	};

	override getChilds(): Component<any, any>[] {
		return ([
			...this.component_innerChilds,
			...this.component_outerChilds
		]);
	};

	component_getParentManifest(): {
		referer: Component<any, any>;
		manifest: TManifest.ManagerManifest | TManifest.ComponentManifest;
	} {
		const p = this.component_parent;
		if (p) {
			if (p.static.manifest) {
				return ({
					referer: p,
					manifest: p.static.manifest
				});
			}
			return (p.component_getParentManifest());
		}
		const rootManifest = window.MPAComponentsManager.Manifest.ManagerManifest.store.get(this);
		if (!rootManifest) {
			this.component_throwLibraryError('No manifest found!', {});
		}
		return {
			referer: this,
			manifest: rootManifest
		};
	};

	component_getManifestsList() {
		const out: TManifest[] = [];
		if (this.static.manifest) {
			out.push(this.static.manifest);
		}
		let c: Component<any, any> = this;
		let res: ReturnType<Component<any, any>['component_getParentManifest']>;
		while ((res = c.component_getParentManifest())) {
			out.push(res.manifest);
			if (!res.referer.component_parent) {
				break;
			}
			c = res.referer;
		}
		return (out);
	};

	component_getSiblings(): Component<any, any>[] {
		if (!this.component_parent) {
			return [];
		}
		if (this.component_tree !== this.component_parent) { // outer childs
			return this.component_parent.component_outerChilds.filter(x => x !== this);
		} else { // inner childs
			return this.component_parent.component_innerChilds.filter(x => x !== this);
		}
	};

	component_get(path: string | string[]) {
		if ((path === '') || !path.length) {
			return (this);
		}
		if (typeof path === 'string') {
			return (STD.object.get(this, path.split('.')));
		} else {
			return (STD.object.get(this, path));
		}
	};

	component_set(_path: string | string[], value: any) {
		const path = typeof _path === 'string' ? _path.split('.') : Array.from(_path);
		const [containerPath, propertyKey] = [path.slice(0, -1), <string>path.slice(-1)[0]];
		const container = this.component_get(containerPath);
		if (!container || (typeof container !== 'object')) {
			this.component_throwUserError('Container is not writable!', {
				path,
				value
			});
		}
		(<Record<string, any>>container)[propertyKey] = value;
		return (value);
	};

	// ┏━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━┓
	// ┃ MISCELLANEOUS                                                  ┃
	// ┠────────────────────────────────────────────────────────────────┨
	// ┃                                                                ┃
	// ┃                                                                ┃
	// ┃                                                                ┃
	// ┃                                                                ┃
	// ┃                                                                ┃
	// ┃                                                                ┃
	// ┗━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━┛
	[key: symbol]: unknown;

	descriptor: Component.TDescriptor;
	id: Component.TId;
	component_isVirtual = true;
	component_configuration: TConfiguration;
	component_boundData: Map<Component<any, any>, unknown> = new Map;
	component_uid: number;

	component_throwUserError(...args: Parameters<typeof STD.errors.user>): never {
		throw STD.errors.user(args[0], Object.assign({
			component: this
		}, args[1]));
	};

	component_throwLibraryError(...args: Parameters<typeof STD.errors.library>): never {
		throw STD.errors.library(args[0], Object.assign({
			component: this
		}, args[1]));
	};

	component_throwBoundError(...args: Parameters<typeof STD.errors.bindAsBound>) {
		throw STD.errors.bindAsBound(
			args[0],
			{
				...args[1],
				component: this
			},
			args[2]
		);
	};

	//Mark the component as deleted, the component will be really deleted or recycled if needed
	async component_delete() {
		await this.component_remove();
		for (const c of [...this.component_innerChilds, ...this.component_outerChilds]) {
			await c.component_delete();
		}
		this.id = '';
		this.component_configuration = <any>{};
		this.component_isStarted = false;
		this.component_linkedTranslations = {};
		this.component_slotsRecords = {};
		this.component_translations.length = 0;
		this.component_boundData.clear();
		this.removeOwnListeners();
	};

	component_getEventWhichRepresentNoEvent(): STD.events.Event<TComponent, Component<any, any>> {
		return (new STD.events.Event({
			type: 'none',
			target: <TComponent><any>this,
			subType: null,
			details: {},
			bubbles: false,
			composed: true,
			cancelable: true
		}));
	};

	component_hasValue() {
		return (false);
	};

	component_defineBinding(boundComponent: Component<any, any>) {
		this.component_boundData.set(boundComponent, {});
	};

	component_getLocalEnv(componentClassId: string) {
		const env: { [key: string]: any } = {};
		for (const [k, v] of Object.entries(this.component_configuration)) {
			if (k.startsWith(componentClassId + '.')) {
				env[k.replace(componentClassId + '.', '')] = v;
			}
		}
		return (env);
	};

	component_getEnv(componentClassId: string) {
		const env = <{ [key: string]: unknown }>{};
		const components = [];
		let c: Component<any, any> | null = this;
		while (c !== null) {
			components.push(c);
			c = c.component_parent;
		}
		const componentEnvPrefix = componentClassId + '.';
		components.reverse().forEach(function (c) {
			if (c.static.name === componentClassId) {
				for (let [key, value] of Object.entries(c.component_configuration)) {
					if (key.startsWith(componentEnvPrefix)) {
						key = key.replace(componentEnvPrefix, '');
					}
					if (
						(typeof env[key] === 'object') &&
						(typeof value === 'object')
					) {
						env[key] = Object.assign({}, value, env[key]);
					} else {
						env[key] = value;
					}
				}
			} else {
				for (let [key, value] of Object.entries(c.component_configuration)) {
					if (key.startsWith(componentEnvPrefix)) {
						key = key.replace(componentEnvPrefix, '');
						if (
							(typeof env[key] === 'object') &&
							(typeof value === 'object')
						) {
							env[key] = Object.assign({}, value, env[key]);
						} else {
							env[key] = value;
						}
					}
				}
			}
		});
		return (env);
	};

	component_matches(selector: string) {
		if (selector === '*') {
			return true;
		}
		const path = this.component_getPath();
		if (path === selector) {
			return true;
		}
		if (selector[0] === '.') {
			return path.endsWith(selector.slice(1));
		}
		//add wildcars handling
		//...
		return false;
	};

	component_warn(msg: string) {
		var args = Array.from(arguments);
		args[0] = 'Component<' + this.id + '>: ' + msg;
		console.warn.apply(console, args);
	};

	private async component_handleEvent(
		evDecl: Component.IListenEvent,
		event: STD.events.Event<any, Component<any, any>>
	) {
		if (evDecl.filter) {
			try {
				if (!await evDecl.filter.evaluate(event)) {
					return;
				}
			} catch (error: any) {
				throw STD.errors.bindAsBound('Component.handleEvent: Error during filter evaluation!', {
					component: this,
					eventHandlerDeclaration: evDecl,
					event: event
				}, error);
			}
		}
		if (evDecl.bypassIfListenerDisabled && this.component_isDisabled) {
			return;
		}
		for (const action of evDecl.actions) {
			void action;
			try {
				await action.execute(this, event);
			} catch (error: any) {
				throw STD.errors.bindAsBound('Component.handleEvent: Error during action evaluation!', {
					action,
					component: this,
					eventHandlerDeclaration: evDecl,
					event: event
				}, error);
			}
		}
	};

	get static(): Component.TAnyConcrete {
		return ((<any>this).constructor[window.MPAComponentsManager.Manager.componentStaticProxySymbol]);
	};

	noop() {
	};

	// ┏━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━┓
	// ┃ INSTANTIATION MANAGEMENT                                       ┃
	// ┠────────────────────────────────────────────────────────────────┨
	// ┃                                                                ┃
	// ┃                                                                ┃
	// ┃                                                                ┃
	// ┃                                                                ┃
	// ┃                                                                ┃
	// ┃                                                                ┃
	// ┗━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━┛
	component_isStarted = false;
	component_isStarting = false;
	component_isInitialized = false;

	async component_initialize() {
		for (const child of this.component_innerChilds) {
			await child.component_initialize();
		}
		for (const child of this.component_outerChilds) {
			if (child.component_isInitialized) {
				continue;
			}
			await child.component_initialize();
		}
		this.component_isInitialized = true;
	};

	// Concrete component must call this method in their constructor when all is done
	// But this is done automatically by the proxy.
	protected async component_finalize() {
		this.component_slotsRecords.default = this;
		this.component_initialPath = this.component_getPath();
		if (this.static.manifest) {
			await this.static.manifest.instantiate(this);
		}
	};

	async component_start(startEvent: STD.events.Event<any, Component<any, any>>) {
		if (this.component_isStarted) {
			this.component_throwUserError('Component already started!', {});
		}
		this.component_isStarting = true;
		try {
			for (const evDecl of (this.component_configuration['@listen'] || [])) {
				try {
					const componentsStringPath: string[] = (
						evDecl.components || [evDecl.component] as any
					);
					for (const componentStringPath of componentsStringPath) {
						const listenedComponents = componentStringPath.includes('**') ?
							this.component_findAll(componentStringPath) :
							[this.component_find(componentStringPath)];
						const eventsName: string[] = evDecl.events ? evDecl.events : [<string>evDecl.event];
						for (const rawEventName of eventsName) {
							const subEvents = evDecl.subEvents || [evDecl.subEvent];
							for (let subEvent of subEvents) {
								let eventName = rawEventName;
								if (eventName.includes('.')) {
									if (evDecl.subEvent) {
										this.component_throwUserError('Cannot have subtype in event and subEvent in same time!', {
											subEvent
										});
									}
									if (eventName[0] === '.') {
										this.component_throwUserError('Cannot have eventName starting with a "."!', {
											subEvent
										});
									}
									const tmp = eventName.split('.');
									eventName = <string>tmp[0];
									subEvent = tmp[1];
								}
								const self = this;
								const thisEventHandlerDeclaration: Component.IListenEvent = {
									event: eventName,
									subEvent: subEvent,
									component: componentStringPath,
									isCapture: evDecl.isCapture,
									isAtTarget: evDecl.isAtTarget,
									priority: evDecl.priority,
									bypassIfListenerDisabled: evDecl.bypassIfListenerDisabled,
									filter: evDecl.filter ? STD.object.PropertyPath.create(evDecl.filter) : null,
									actions: evDecl.actions.map(action => new window.MPAComponentsManager.PropertyOperation.CallOperation({
										...action,
										get componentPath() {
											return Path.parse(self.component_getPath());
										},
										type: 'call'
									}))
								};
								for (const listenedComponent of listenedComponents) {
									const listener = new STD.events.Listener<any, Component<any, any>, Component.IListenEvent>({
										listener: this,
										isCapture: evDecl.isCapture,
										isAtTarget: evDecl.isAtTarget,
										subType: thisEventHandlerDeclaration.subEvent,
										callback: this.component_handleEvent.bind(this, thisEventHandlerDeclaration),
										priority: evDecl.priority,
										type: eventName,
										target: listenedComponent,
										disableEventExistsCheck: evDecl.disableEventExistsCheck,
										implementationInfos: thisEventHandlerDeclaration
									});
									listenedComponent.addEventListener(eventName, listener);
								}
							}
						}
					}
				} catch (error: any) {
					throw STD.errors.bindAsBound(
						'Cannot add event listener',
						{
							component: this,
							eventListenerDeclaration: evDecl
						},
						error
					);
				}
			}
			if (this.component_configuration['@isDisabled']) {
				await this.component_disable();
			}
			if (this.component_condition) {
				await this.component_evaluateCondition();
			}
			for (const c of [...this.component_innerChilds, ...this.component_outerChilds]) {
				if (
					c.component_configuration['@disableAutoStart'] ||
					c.component_isStarted
				) {
					continue;
				}
				await c.component_start(startEvent.copy(c));
			}
		} catch (error: any) {
			throw STD.errors.bindAsBound(
				'Cannot initialize component',
				{component: this},
				error
			);
		}
		this.component_isStarted = true;
		this.component_isStarting = false;
		await this.dispatchEvent('start');
		if (!this.component_isDisabled) {
			await this.dispatchEvent('activation', {
				subType: 'enabled'
			});
		}
	};

	component_findReferencesInConfig() {
		const references: { component: Component<any, any>, propertyPath: string }[] = [];

		if (this.component_configuration['@listen']) {
			for (const [idx, listener] of Object.entries(this.component_configuration['@listen'])) {
				const {component: componentPath, components} = listener;

				if (componentPath) {
					const component = componentPath.includes('*')
						? this.component_findMaybe(componentPath)
						: this.component_find(componentPath);

					if (!component) continue;

					references.push({
						component,
						propertyPath: `@listen.${idx}.component`
					});

				} else if (components) {
					for (const [cIdx, componentPath] of Object.entries(components)) {
						const component = componentPath.includes('*')
							? this.component_findMaybe(componentPath)
							: this.component_find(componentPath);

						if (!component) continue;

						references.push({
							component,
							propertyPath: `@listen.${idx}.components.${cIdx}`
						});
					}
				}
			}
		}

		if (this.component_configuration['@condition']) {
			const stack: [string, TCondition.TSerialized][] = [['@condition', this.component_configuration['@condition']]];

			while (stack.length > 0) {
				const [propertyPath, condition] = <[string, TCondition.TSerialized]>stack.shift();

				if (TCondition.ScalarCondition.isSerializedScalar(condition)) {
					const component = condition.component.includes('*')
						? this.component_findMaybe(condition.component)
						: this.component_find(condition.component);

					if (!component) continue;

					references.push({
						component,
						propertyPath: propertyPath + '.component'
					});

				} else {
					stack.push(
						[propertyPath + '.LHS', condition.LHS],
						[propertyPath + '.RHS', condition.RHS]
					);
				}
			}

		}

		return references;
	}

	component_addEventListener(
		listener: Component<any, any>,
		descriptor: Omit<Component.IListenEventDescriptor, 'events' | 'subEvents' | 'component' | 'components' | 'priority'> & {
			event: string,
			subEvent: string
		}
	) {
		const eventHandlerDeclaration: Component.IListenEvent = {
			event: descriptor.event,
			subEvent: descriptor.subEvent,
			isCapture: descriptor.isCapture,
			isAtTarget: descriptor.isAtTarget,
			filter: descriptor.filter ? STD.object.PropertyPath.create(descriptor.filter) : null,
			bypassIfListenerDisabled: descriptor.bypassIfListenerDisabled,
			disableEventExistsCheck: descriptor.disableEventExistsCheck,
			component: this.component_getPath(),
			actions: descriptor.actions.map(action => new TPropertyOperation.CallOperation({
				...action,
				componentPath: listener.component_getPath(),
				type: 'call'
			}))
		};

		const eventListener = new STD.events.Listener<any, Component<any, any>, Component.IListenEvent>({
			listener,
			target: this,
			type: descriptor.event,
			subType: descriptor.subEvent,
			isCapture: descriptor.isCapture,
			isAtTarget: descriptor.isAtTarget,
			callback: this.component_handleEvent.bind(this, eventHandlerDeclaration),
			disableEventExistsCheck: descriptor.disableEventExistsCheck,
			implementationInfos: eventHandlerDeclaration
		});

		this.addEventListener(descriptor.event, eventListener);
	};

	component_contains(otherComponent: Component<any, any>) {
		let current = otherComponent;
		while (current.component_parent) {
			if (current === this) {
				return true;
			}
			current = current.component_parent;
		}
		return false;
	};

	constructor(
		descriptor: Component.TDescriptor,
		configuration: TConfiguration
	) {
		super({});
		if (descriptor.isRoot) {
			window.MPAComponentsManager.Manager.setRoot(this as any);
		}
		if (descriptor.id === undefined) {
			if (descriptor.parent) {
				this.component_throwUserError(
					(
						'new Component@descriptor.id is undefined ' +
						`at path<${descriptor.parent.component_getPath()}>!`
					),
					{
						descriptor,
						configuration
					}
				);
			} else {
				this.component_throwUserError(
					'new Component@descriptor.id is undefined!',
					{
						descriptor,
						configuration
					}
				);
			}
		}
		this.descriptor = descriptor;
		this.component_configuration = configuration;
		this.component_parent = descriptor.parent;
		this.id = descriptor.id;
		this.component_uid = Component.uid++;
		this.component_isSlot = descriptor.isSlot;
		this.component_tree = (
			descriptor.tree ||
			(descriptor.parent ? descriptor.parent.component_tree : this)
		);
		const additionalConf = window.MPAComponentsManager.Manager.manifest.configurations[this.component_getPath()];
		if (
			additionalConf &&
			(
				!additionalConf['@marker'] ||
				(additionalConf['@marker'] !== this.component_configuration['@marker'])
			)
		) {
			STD.object.deepMergeAssign(this.component_configuration, [additionalConf]);
		}
		if (this.component_hasInnerTree()) {
			const conf = (this.static.manifest ? (this.static.manifest.configurations.template) : {}) || {};
			STD.object.deepMergeAssign(this.component_configuration, [conf]);
		}
		window.MPAComponentsManager.Manager.storeInstances.add(this);
		for (const Class of this.static.inheritanceChain) {
			const ClassOrProxy = <typeof Component>(<any>Class)[window.MPAComponentsManager.Manager.componentStaticProxySymbol];
			const store = window.MPAComponentsManager.Manager.storeInstancesByType.get(<Component.TAnyConcrete><any>ClassOrProxy);
			if (!store) {
				this.component_throwLibraryError('Components store instances unbound to class component!', {
					Class
				});
			}
			store.push(this);
		}
		if (!this.component_parent && !descriptor.isRoot) {
			this.component_throwUserError('Cannot instantiate a non root component without giving parent!', {
				descriptor
			});
		}
		if (this.component_configuration['@listen']) {
			for (const listener of this.component_configuration['@listen']) {
				if (('component' in listener) && ('components' in listener)) {
					this.component_throwUserError('Listener "component" and "components" properties are exclusive', listener);
				}

				if ('component' in listener) {
					if (typeof listener.component !== 'string') {
						this.component_throwUserError('Listener property "component" must be a string', listener);
					}

				} else if ('components' in listener) {
					if (!Array.isArray(listener.components) || listener.components.some(c => typeof c !== 'string')) {
						this.component_throwUserError('Listener property "components" must be an array of string', listener);
					}

				} else {
					this.component_throwUserError('Listener missing "component" or "components" property', listener);
				}
			}
		}
		if (this.component_configuration['@translations']) {
			const translations = Array.from(
				Object.entries(this.component_configuration['@translations'])
			);
			for (const [suffix, tm] of translations) {
				this.component_defineTranslation(suffix, tm);
			}
		}
		if (this.component_configuration['@conditionSchema']) {
			if (this.component_configuration['@condition']) {
				this.component_throwUserError('Condition schema without condition!', {});
			}
			this.component_configuration['@condition'] = generateConditionFromSchema(
				this.component_configuration['@conditionSchema']
			);
		}
		if (this.component_configuration['@condition']) {
			this.component_condition = window.MPAComponentsManager.Condition.deserialize(this.component_configuration['@condition']);
		}
		this.addEventListener('internal-activation', this.component_onInternalActivation.bind(this), {
			listener: <TComponent><any>this,
			subType: '*'
		});
		this.addEventListener('activation', this.component_onActivationChange.bind(this), {
			listener: <TComponent><any>this,
			subType: '*',
			isAtTarget: true
		});
	};
};
namespace Component {
	export type TId = string;
	export type TAny = Component<any, any>;
	export type TAbstract = typeof Component;
	export type TAnyConcrete = (
		Omit<TAbstract, 'new'> &
		STD.object.TClass<TAny, any>
		);

	export interface IDescriptorNotSlot extends Omit<TreeNode.Node.INotSlot<any>, 'configuration'> {
		parent: Component<any, any> | null;
		tree: Component<any, any> | null;
		isRoot: boolean;
	};

	export interface IDescriptorSlot extends Omit<TreeNode.Node.ISlot<any>, 'configuration'> {
		parent: Component<any, any> | null;
		tree: Component<any, any> | null;
		isRoot: boolean;
	};
	export type TDescriptor = IDescriptorNotSlot | IDescriptorSlot;

	export interface IListenEventDescriptor {
		event?: string;
		events?: string[];
		subEvent?: string;
		subEvents?: string[];
		isCapture?: boolean;
		isAtTarget?: boolean;
		actions: Omit<TPropertyOperation.CallOperation.IDescriptor, 'componentPath' | 'type'>[];
		component?: Path.TPathRaw;
		components?: Path.TPathRaw[];
		priority?: number;
		filter?: string;
		bypassIfListenerDisabled?: boolean;
		disableEventExistsCheck?: boolean;
		// actions : (PropertyOperation.CallOperation.IDescriptor | string)[];
	};

	export interface IListenEventComponentDescriptor extends IListenEventDescriptor {
		event: string;
		component: Path.TPathRaw;
	};

	export interface IListenEventComponentsDescriptor extends IListenEventDescriptor {
		event: string;
		components: Path.TPathRaw[];
	};

	export interface IListenEventsComponentDescriptor extends IListenEventDescriptor {
		events: string[];
		component: Path.TPathRaw;
	};

	export interface IListenEventsComponentsDescriptor extends IListenEventDescriptor {
		events: string[];
		components: Path.TPathRaw[];
	};

	export type TComponentListenEventDescriptor = (
		IListenEventComponentDescriptor |
		IListenEventComponentsDescriptor |
		IListenEventsComponentDescriptor |
		IListenEventsComponentsDescriptor
		);

	export interface IListenEvent extends Omit<TComponentListenEventDescriptor, 'action' | 'actions' | 'filter'> {
		actions: TPropertyOperation.CallOperation[];
		filter: STD.object.TPropertyPath | null;
	};

	export interface IConditionSchema {
		variables: Record<string, string>;
		src: string[] | string;
	};

	export interface IConfiguration {
		'@marker'?: string;
		'@isDisabled'?: boolean;
		'@stringData'?: string;
		'@translations'?: Record<string, STD.translationsManager.TranslationMapping>;
		'@listen'?: TComponentListenEventDescriptor[];
		/**
		 * At startup if @disabled filled, the condition will not be evaluated
		 * evaluateCondition must be called manually or registered via @listen
		 **/
		'@condition'?: TCondition.TSerialized;
		'@conditionSchema'?: IConditionSchema;
		'@innerConfigurations'?: Record<Path.TPathRaw, IConfiguration>;
		'@disableAutoStart'?: boolean;
		// A deferred configuration is a configuration allowed to be declared before their respective component declaration(For exemple if the component is dynamically loaded)
		'@isDeferred'?: boolean;
	};

	export interface IConditionVariableCP {
		component: string;
		property: string;
	};
	export type TConditionVariableValue = string | boolean | number | {
		variable: string;
	};
	export type TConditionVariables = Record<string, IConditionVariableCP>;

	export interface IConditionToken {
		type: 'lexBin' | 'bin' | 'value' | 'lexGroup';
		value?: TConditionVariableValue;
		ctype?: string;
		counted?: boolean;
		LHS?: IConditionToken | TConditionVariableValue;
		RHS?: IConditionToken | TConditionVariableValue;
	};

	export namespace TreeNode {
		export namespace Node {
			export interface INodeBase<
				TConfiguration extends IConfiguration
			> {
				/** The component type. **/
				type: string;
				/** The component id. **/
				id: Component.TId;
				configuration: TConfiguration | null;
				/** The slot in which the component will go. **/
				slot: string | null;
				isSlot: boolean;
			};

			export interface INotSlot<
				TConfiguration extends IConfiguration
			> extends INodeBase<TConfiguration> {
				isSlot: false;
			};

			export interface ISlot<
				TConfiguration extends IConfiguration
			> extends INodeBase<TConfiguration> {
				isSlot: true;
				/** The slot name. **/
				declaredSlot: string;
			};

			export type TNode<
				TConfiguration extends IConfiguration
			> = INotSlot<TConfiguration> | ISlot<TConfiguration>;
		}
		export namespace RecursiveNode {
			export interface INotSlot<
				TConfiguration extends IConfiguration
			> extends TreeNode.Node.INotSlot<TConfiguration> {
				childs: TNode<IConfiguration>[];
			};

			export interface ISlot<
				TConfiguration extends IConfiguration
			> extends TreeNode.Node.ISlot<TConfiguration> {
				childs: TNode<IConfiguration>[];
			};

			export type TNode<
				TConfiguration extends IConfiguration
			> = INotSlot<TConfiguration> | ISlot<TConfiguration>;
		}
	}

	export interface IInstantiateChildNotSlotDescriptor<
		TConfiguration extends IConfiguration
	> extends TreeNode.Node.INotSlot<TConfiguration> {
		tree: Component<any, any>;
		parentNode?: HTMLElement | null; // Cannot have a slot and a parentNode or a beforeNode in same time.
		beforeNode?: HTMLElement | null; // Cannot have a slot and a parentNode or a beforeNode in same time.
	};

	export interface IInstantiateChildSlotDescriptor<
		TConfiguration extends IConfiguration
	> extends TreeNode.Node.ISlot<TConfiguration> {
		tree: Component<any, any>;


		parentNode?: HTMLElement | null; // Cannot have a slot and a parentNode or a beforeNode in same time.
		beforeNode?: HTMLElement | null; // Cannot have a slot and a parentNode or a beforeNode in same time.
	};

	export type TInstantiateChildDescriptor<
		TConfiguration extends IConfiguration
	> = IInstantiateChildNotSlotDescriptor<TConfiguration> | IInstantiateChildSlotDescriptor<TConfiguration>;

}
export default Component;
// ╭───────────────────────────────────────────────────────────────────────────╮
// │ ╳╳╳╳╳╳╳╳╳╳╳╳╳╳╳╳╳╳╳╳╳╳╳╳╳╳╳╳╳╳╳╳╳╳╳╳╳╳╳╳╳╳╳╳╳╳╳╳╳╳╳╳╳╳╳╳╳╳╳╳╳╳╳╳╳╳╳╳╳╳╳╳╳ │
// ╰───────────────────────────────────────────────────────────────────────────╯
import type TManifest     from './Manifest';
import Path               from './Path';
import TPropertyOperation from './PropertyOperation';
import TCondition         from './Condition';
import type TManager      from './Manager';
import IDescriptorSlot = Component.IDescriptorSlot;
